import Storage from '@/utils/Storage'

export default {
  intro: {
    key: null,
    type: 'intro',
    status: 'finished', // default: 'finished'; valid: ['finished', 'started']
  },
  embed: {
    captionsColor: Storage.getItem('captionsColor') ?? '#ffffffff',
    captionsBackgroundColor:
      Storage.getItem('captionsBackgroundColor') ?? '#000000ff',
  },
  warnings: {
    isCardsLoaded: false,
    showActionButtonType: 'oneButton',
  },
  isAdBlockEnabled: false,
}
